import { RootState } from '../index';

const getRegisteredUser = (state: RootState) => state.onboardingReducer.registeredUser;

const getIsOpenPricingNav = (state: RootState) => state.onboardingReducer.isOpenPricingNav;

const getInviteMembers = (state: RootState) => state.onboardingReducer.inviteMembers;

export {
  getRegisteredUser,
  getIsOpenPricingNav,
  getInviteMembers,
};
